<template>
  <a-card :bordered='false'>
    <a-table :columns="columns" :data-source="candidates" :pagination="false">
        <span slot="action" slot-scope="text, record, index">
          <a-select style='width: 200px'
                    :default-value="record.isPass == null ? '1' : record.isPass"
                    :disabled='isCheckProtocolBidder'
                    @change="e => handleChange(e,index)">
            <a-select-option :value="'1'" >
              否
            </a-select-option>
            <a-select-option :value="'0'">
              是
            </a-select-option>
          </a-select>
        </span>
        <span slot="reasonAction" slot-scope="text, record, index">
         <a-textarea
            v-model="record.disuseReason"
            :disabled="isCheckProtocolBidder"
         />
        </span>
    </a-table>

    <div align="center" style='padding-top: 20px;'>
      <a-button v-if='!isCheckProtocolBidder && isHeadman' :loading='isCheckProtocolBidderLoading' type="primary" @click="endCandidate">
        确认拟推荐中标候选人
      </a-button>
    </div>
  </a-card>
</template>

<script>

import { httpAction, getAction, postAction,putAction } from '@/api/manage'
import { message } from 'ant-design-vue'
import pick from 'lodash.pick'

export default {
  name: 'ProtocolCandidate',
  data() {
    return {
      isHeadman:false,
      candidates: [],
      bidEvaluationWayId:"",
      columns: [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function(t, r, index) {
            return parseInt(index) + 1
          }
        },
        {
          title: '企业名称',
          dataIndex: 'bidderName',
          customRender: function(t, r, index) {
            let name=t;
            if (r.unionEnterpriseName){
              name= name+"(联合体成员：" + r.unionEnterpriseName + ")"
            }
            if(r.subpackageName)
            {
              name=name+" (分包企业：" + r.subpackageName + ")"
            }
            return name;
          }
        },
        {
          title: '统一社会信用代码',
          dataIndex: 'bidderOrgCode',
        },
        {
          title: '投标报价(元)',
          dataIndex: 'bidPrice',
        },
      ],
      isCheckProtocolBidder: true,
      isCheckProtocolBidderLoading: false,
    }
  },
  props: ['instStepId','workflowInstanceId','sectionId'],
  created() {
    this.getOpenConfig();
    this.getCandidateInfo();
    this.getCheckStatus();
    this.getCommitteeMemExpert();
  },
  methods: {
    //是否是组长
    getCommitteeMemExpert() {
      getAction('/ebid-ce/boCommitteeMem/getCommitteeMemExpert/' + this.workflowInstanceId , {}).then(res => {
        if (res.success) {
          this.isHeadman = res.result
        } else {
        }
      })
    },
    getCheckStatus() {
      getAction('/ebid-ce/boAppraiseStatus/getBoAppraiseStatus/' + this.workflowInstanceId , {}).then(res => {
        if (res.success) {
          if( res.result != null && res.result.isCheckProtocolBidder != "1") {
            this.isCheckProtocolBidder = false;
          }
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    getOpenConfig()
    {
      getAction('/ebid-ce/boOpenConfig/getBoOpenConfig/' + this.sectionId , {}).then(res => {
        if (res.success) {
          this.bidEvaluationWayId = res.result.bidEvaluationWayId;
        } else {
          this.$message.warning(res.message)
        }
      });
    },
    getCandidateInfo() {
      let that=this;
      this.isCheckProtocolBidderLoading=true;
      getAction('/ebid-ce/boCandidate/getBoCandidate/' + this.sectionId + "/" + this.workflowInstanceId + "/" + this.instStepId , {}).then(res => {
        if (res.success) {
          this.candidates = res.result;
          let candidate = this.candidates[0];
          if(candidate.candidateScoreInfoDTOS != null) {
            for (let i = 0; i < candidate.candidateScoreInfoDTOS.length; i++) {
              let model = {};

              model.title = candidate.candidateScoreInfoDTOS[i].name.replace("得分","") + "得分"
              model.dataIndex = "score" + i;
              this.columns.push(model)
            }

            for(let i = 0; i<this.candidates.length; i++) {
              for(let j = 0; j<this.candidates[i].candidateScoreInfoDTOS.length; j++) {
                this.candidates[i]["score" + j] = this.candidates[i].candidateScoreInfoDTOS[j].evalScore;
              }
            }
          }
          //如果是信息化低价，新增扣除展示
          if(this.bidEvaluationWayId==='192')
          {
            let model = {};
            model.title = "扣除后价格"
            model.dataIndex = "appraisePrice"
            this.columns.push(model);
          }

          let model = {};
          model.title = "是否否决投标"
          model.dataIndex = "isPass"
          model.scopedSlots = { customRender: 'action', };
          this.columns.push(model);

          let reasonModel = {};
          reasonModel.title = "否决投标原因"
          reasonModel.dataIndex = "disuseReason"
          reasonModel.scopedSlots = { customRender: 'reasonAction', };
          this.columns.push(reasonModel);
        } else {
        }
      }).finally( () => {
        that.isCheckProtocolBidderLoading=false;
      })
    },
    handleChange(value , index) {
      this.candidates[index].isPass = value;
    },
    endCandidate() {
      let that = this;
      let datas = [];
      for (let i = 0; i < this.candidates.length; i++) {
        if (that.candidates[i].isPass == '0' && !that.candidates[i].disuseReason ){
          this.$message.error("否决投标，需填写否决投标原因")
          return;
        }
        if (that.candidates[i].isPass != '0' && that.candidates[i].disuseReason){
          this.$message.error("未否决投标，不能填写否决投标原因")
          return;
        }
        let data = {};
        data.bidderId = that.candidates[i].bidderId;
        data.bidderName = that.candidates[i].bidderName;
        data.bidderCode = that.candidates[i].bidderOrgCode;
        data.isPass = that.candidates[i].isPass;
        data.disuseReason = that.candidates[i].disuseReason;
        data.workflowInstanceId = that.workflowInstanceId;
        data.instStepId = that.instStepId;
        data.sectionId = that.sectionId;
        datas.push(data)
      }
      this.isCheckProtocolBidderLoading = true;
      this.$confirm({
        title: '提示',
        content: '确定提交拟推荐中标候选人吗?',
        okText: '确定',
        /*okType: 'danger',*/
        cancelText: '取消',
        onOk() {
          postAction('/ebid-ce/boGroupResults/endCheckProtocolBidder/' + that.workflowInstanceId + "/" + that.instStepId , datas).then((res) => {
            if (res.success) {
              that.isCheckProtocolBidder = true;
              that.$emit('getNewWfInst');
              that.$message.success("当前环节已结束！");
              that.isCheckProtocolBidderLoading = false;
            } else {
              that.$message.error(res.message);
              that.isCheckProtocolBidderLoading = false;
            }
          }).catch(() => {
            that.$message.error("当前操作失败，请重试！");
            that.isCheckProtocolBidderLoading = false;
          })
        },
        onCancel() {
          that.isCheckProtocolBidderLoading = false
          console.log('Cancel');
        },
      });
    },
  }
}
</script>

<style scoped>

</style>